// Chat-header action glyphs (Figma "Header" 14701:127253): the Symphony Icon Button spec — 16px
// lucide at 1.5px absoluteStrokeWidth. compose = SquarePen, expand = Maximize2 (two diagonal
// arrows, ↙↗), shrink = Minimize2, close = X, search = Search, files = File (Figma "16/file" —
// a plain document, not a folder).
import { File, Maximize2, Minimize2, Search, SquarePen, X } from 'lucide-react';

export function NewConversationIcon({ size = 16 }: { size?: number }) {
  return <SquarePen size={size} strokeWidth={1.5} absoluteStrokeWidth aria-hidden />;
}

export function SearchIcon() {
  return <Search size={16} strokeWidth={1.5} absoluteStrokeWidth aria-hidden />;
}

export function ShrinkIcon() {
  return <Minimize2 size={16} strokeWidth={1.5} absoluteStrokeWidth aria-hidden />;
}

export function ExpandIcon() {
  return <Maximize2 size={16} strokeWidth={1.5} absoluteStrokeWidth aria-hidden />;
}

export function CloseIcon() {
  return <X size={16} strokeWidth={1.5} absoluteStrokeWidth aria-hidden />;
}

export function FilesIcon() {
  return <File size={16} strokeWidth={1.5} absoluteStrokeWidth aria-hidden />;
}
